import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        errors: '=',
        form: '=',
        companyTerms: '='
    },
    template: `
        <div class="terms01 large">
            <h3 ng-if="vm.companyTerms">{{ 'user.Terms and Conditions' | translate }}</h3>
            <p ng-bind-html="vm.companyTerms"></p>
            <h3>{{ 'user.Coursy site privacy policy' | translate }}</h3>
            <div ng-bind-html="vm.coursyTerms"></div>
        </div>
        <div class="form">
            <form-row ng-if="!vm.isInitialAdmin" error="vm.errors.password">
                <label class="label">{{ 'user.New password' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.form.password" type="password" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row ng-if="!vm.isInitialAdmin" error="vm.errors.repeatPassword">
                <label class="label">{{ 'user.Repeat password' | translate }}</label>
                <div class="items">
                    <input ng-model="vm.form.repeatPassword" type="password" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.errors.hasAgreedTerms">
                <ul class="checkboxes">
                    <li><label><input ng-model="vm.form.hasAgreedTerms" type="checkbox"> {{ 'user.I have read the terms and conditions' | translate }}</label></li>
                    <form-row-error></form-row-error>
                </ul>
            </form-row>
        </div>
    `
})
export default class {
    constructor ($translate, TokenService, UserResource) {
        this.$translate = $translate;
        this.TokenService = TokenService;
        this.UserResource = UserResource;
        this.coursyTerms = this.$translate.instant('user.Coursy terms and conditions');
        this.isInitialAdmin = false;
    }

    $onInit () {
        this.validateIsUserInitialAdmin();
    }

    validateIsUserInitialAdmin () {
        const user = this.TokenService.getUser();

        if (user) {
            this.UserResource.get({ id: user.id }).$promise
                .then((response) => {
                    this.isInitialAdmin = response.isInitialAdmin;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activate/index.js